import { Actions } from '../../interfaces'
import { Inspection } from '@/entities/purchase'

import create from './create'
import fetch from './fetch'
import fetchLite from './fetchLite'
import update from './update'
import find from './find'

export const actions: Actions = {
  create,
  fetch,
  fetchLite,
  update,
  find,
}

export default {
  Model: { Inspection },
  actions: { [Inspection.name]: actions },
}
